import React from "react";
import { Box, Popover } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import usePopover from "components/hooks/usePopover";
import { FleetFragment } from "__generated__/view/fleets/graphql/fleet.fragments.generated";

const FleetShipListPopover = ({ ships }: { ships: FleetFragment["ships"] }) => {

	const { popoverProps, onPopoverOpen } = usePopover({
		trigger: "click",
	});

	if (ships && ships.length > 0) {
		return (
			<div>
				<span onClick={onPopoverOpen} style={{ alignItems: "center", display: "flex" }}>
					{ships.length}
					<InfoOutlinedIcon fontSize="small" style={{ marginLeft: 4 }} />
				</span>

				<Popover {...popoverProps}>
					<Box sx={{ padding: 1, maxHeight: 150, overflow: "auto" }}>
						<div>
							{ships.map((ship, index) => <div key={index}>{ship.name}</div>)}
						</div>
					</Box>
				</Popover>
			</div>
		);
	} else {
		return <React.Fragment />;
	}
};

export default FleetShipListPopover;
